import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, FormattedNumber} from "react-intl";

import {styled} from "@mui/material/styles";

import Badge from "components/Badge";
import CustomTooltip from "components/CustomTooltip";

ListingCtrBadge.propTypes = {
    ctr: PropTypes.number,
};

const TooltipAnchor = styled('span')({
    display: 'inline-flex'
});

const GOOD_CTR_THRESHOLD = 3;
const AVERAGE_CTR_THRESHOLD = 1.8;

export function getCtrBadgeColor(ctr) {
    if (ctr >= GOOD_CTR_THRESHOLD) {
        return 'online';
    }

    if (ctr >= AVERAGE_CTR_THRESHOLD) {
        return 'warning';
    }

    return 'error';
}

function ListingCtrBadge({ctr}) {
    if (null === ctr || undefined === ctr) {
        return null;
    }

    return (
        <CustomTooltip title={<FormattedMessage id={"retailer.product.list.scoring.ctr.tooltip"}/>}>
            <TooltipAnchor>
                <Badge rounded color={getCtrBadgeColor(ctr)} border icon="end" iconSize={12}>
                    <FormattedMessage id={"retailer.product.list.scoring.ctr"} values={{value: <FormattedNumber value={ctr} maximumFractionDigits={2}/>}}/>
                </Badge>
            </TooltipAnchor>
        </CustomTooltip>
    );
}

export default ListingCtrBadge;
